module.exports = __webpack_public_path__ + "img/home-img-7.83004cf3.webp";